import script from "./PermissionTreeRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionTreeRow.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionTreeRow.vue?vue&type=style&index=0&id=24ff2403&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ff2403"]])

export default __exports__